/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Formats a date for the text input
 */

import format from 'date-fns/format'

import { UndefinedOrDate } from '../types'

export const getInputDateFormat = (date: UndefinedOrDate) =>
  date ? format(date, 'MM/dd/yyyy') : date
